/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LoginModule
 */

import { Component } from '@angular/core';

import { InitialDataService } from 'ng/modules/core/services/initial-data/initial-data.service';

import './login-banner.component.less';

/**
 * @description
 *      Login-banner component
 *
 * @author Aravindh Nagarajan
 */
@Component({
    selector: 'login-banner',
    templateUrl: './login-banner.component.html',
})
export class LoginBannerComponent {
    /**
     * Banner from initData
     */
    public loginBanner = '';

    public constructor(initialDataService: InitialDataService) {
        this.loginBanner = initialDataService.controllerBanner;
    }

    /**
     * Returns true if banner is configured.
     */
    public hasBanner(): boolean {
        return Boolean(this.loginBanner);
    }
}
